import { useMemo as m } from "react";
import { A as a } from "../../../index.modern-BBWGIH4W.js";
import "react/jsx-runtime";
import "styled-components";
import { useThemeInMode as i } from "../../../context/theme/hooks.js";
import { FOREGROUND_VARIANT_TO_OVERLAY_OPACITY_MAP as l } from "../consts.js";
import { baseColorHexToRGBA as u, overlayColorHexToRGBA as A, RGBAToString as f } from "../utils.js";
function g(r) {
  const o = i();
  return m(() => {
    const e = u(o.foreground), t = A(
      o["foreground-variant-overlay"],
      l[r]
    ), n = a(e, t);
    return f(n);
  }, [o, r]);
}
export {
  g as default
};
